import {useState} from 'react'
import {Modal, useOpenModal} from '@/components/Modal/index.mjs'
import Table from '@/components/Table/Table.jsx'
import useBaselines from './useBaselines.mjs'

const TableBaselines = ({
    rowSelection,
    onChange,
    ...props
}) => {
    const columns = [
        {
            title: '分支名称',
            dataIndex: 'pblName',
            component: <Table.ViewText />,
        },

        {
            title: '分支版本',
            dataIndex: 'sVer',
            component: <Table.ViewText />,
        },
    ]

    const rs = {
        onChange: (_, selectedRows) => onChange(selectedRows),
        type: 'radio',
        ...rowSelection,
    }

    return (
        <Table
            columns={columns}
            rowKey="pkid"
            rowSelection={rs}
            selectRowOnClick
            {...props}
        />
    )
}

const ModalChooseBaseline = ({
    defaultSelect,
    defaultSelectAll,
    defaultSelectFirst,
    disabled,
    isDesc,
    pblStsCodes,
    pblType,
    prjId,
    prjPatternId,
    onOk,
    ...props
}) => {
    const [baseline, setBaseline] = useState()

    const {data: dataSource, isLoading} = useBaselines({
        isDesc,
        pblStsCodes,
        pblType,
        prjId,
        prjPatternId,
    })

    const okButtonProps = {disabled: ! baseline}
    const onTableChange = rows => setBaseline(rows[0])
    const _onOk = () => onOk(baseline)

    return (
        <Modal
            okButtonProps={okButtonProps}
            title="选择分支"
            onOk={_onOk}
            {...props}
        >
            <TableBaselines
                dataSource={dataSource}
                loading={isLoading}

                rowSelection={{
                    defaultSelect,
                    defaultSelectAll,
                    defaultSelectFirst,
                    disabled,
                }}

                onChange={onTableChange}
            />
        </Modal>
    )
}

export default () => {
    const openModal = useOpenModal()

    return ({
        isDesc,
        pblProgress,
        pblStsCodes,
        pblType,
        prjId,
        prjPatternId,
        ...props
    }) => openModal(
        <ModalChooseBaseline
            isDesc={isDesc}
            pblProgress={pblProgress}
            pblStsCodes={pblStsCodes}
            pblType={pblType}
            prjId={prjId}
            prjPatternId={prjPatternId}
            {...props}
        />
    )
}
